import { defineMessages } from 'react-intl'

export default defineMessages({
  business: {
    id: 'categories.business',
    defaultMessage: 'Business',
  },
  businessDescription: {
    id: 'categories.business-description',
    defaultMessage: 'Workshops, classes, conferences, seminars, meetups',
  },
  comedy: {
    id: 'categories.comedy',
    defaultMessage: 'Comedy',
  },
  comedyDescription: {
    id: 'categories.comedy-description',
    defaultMessage: 'Comedy shows, standups, clubs',
  },
  crafts: {
    id: 'categories.crafts',
    defaultMessage: 'Crafts',
  },
  craftsDescription: {
    id: 'categories.crafts-description',
    defaultMessage: 'Workshops, markets, fairs, series, expo',
  },
  fashion: {
    id: 'categories.fashion',
    defaultMessage: 'Fashion',
  },
  fashionDescription: {
    id: 'categories.fashion-description',
    defaultMessage: 'Expos, shows, meetups',
  },
  film: {
    id: 'categories.film',
    defaultMessage: 'Film',
  },
  filmDescription: {
    id: 'categories.film-description',
    defaultMessage: 'Indie films, premieres, festivals, competitions',
  },
  foodDrink: {
    id: 'categories.food-drink',
    defaultMessage: 'Food & Drink',
  },
  foodDrinkDescription: {
    id: 'categories.food-drink-description',
    defaultMessage: 'Dinner series, festivals, classes, food tours, workshops',
  },
  galleries: {
    id: 'categories.galleries',
    defaultMessage: 'Galleries',
  },
  galleriesDescription: {
    id: 'categories.galleries-description',
    defaultMessage: 'Museums, exhibitions, fundraisers',
  },
  music: {
    id: 'categories.music',
    defaultMessage: 'Music',
  },
  musicDescription: {
    id: 'categories.music-description',
    defaultMessage: 'Concerts, festivals, classes, live music',
  },
  performances: {
    id: 'categories.performances',
    defaultMessage: 'Performances',
  },
  performancesDescription: {
    id: 'categories.performances-description',
    defaultMessage: 'Theatre, live entertainment',
  },
  social: {
    id: 'categories.social',
    defaultMessage: 'Social',
  },
  socialDescription: {
    id: 'categories.social-description',
    defaultMessage: 'Meetups, summit, festivals, networking, workshops',
  },
  sports: {
    id: 'categories.sports',
    defaultMessage: 'Sports',
  },
  sportsDescription: {
    id: 'categories.sports-description',
    defaultMessage: 'Festivals, events, classes, clinics, training events',
  },
  tech: {
    id: 'categories.tech',
    defaultMessage: 'Tech',
  },
  techDescription: {
    id: 'categories.tech-description',
    defaultMessage: 'Conferences, meetups, galas, dinners, workshops',
  },
  other: {
    id: 'categories.other',
    defaultMessage: 'Other',
  },
})
